/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import {useAuth} from '../../../../app/modules/auth';
import {Languages} from './Languages';
import imagePlug from '../../../assets/media/user.png';
import {observer} from 'mobx-react';
import {useStore} from '../../../../store/store';

const HeaderUserMenu = observer(({data}) => {
  const store = useStore();

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5 bg-secondary'>
            <img
              className='object-fit-cover'
              src={!!data?.avatar ? `${process.env.REACT_APP_API_HOST}/${data?.avatar}` : imagePlug}
              alt='#'
            />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {data?.first_name} {data?.last_name}
              {/* <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>Pro</span> */}
            </div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
              {data?.email}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <Link to={'/account/info'} className='menu-link px-5'>
          Мой аккаунт
        </Link>
      </div>
      <div className='menu-item px-5'>
        <Link to={'/wallet'} className='menu-link px-5'>
          Кошелек
        </Link>
      </div>
      <div className='menu-item px-5'>
        <Link to={'/account/security'} className='menu-link px-5'>
          Безопасность
        </Link>
      </div>

      <div className='separator my-2'></div>

      {/* <Languages /> */}

      <div className='menu-item px-5 my-1'>
        <Link to='/account/settings' className='menu-link px-5'>
          Настройки
        </Link>
      </div>

      <div className='menu-item px-5'>
        <a onClick={() => store.signOut()} className='menu-link px-5'>
          Выход
        </a>
      </div>
    </div>
  );
});

export {HeaderUserMenu};
